import React, { useEffect, useRef, useState } from "react";
import Typography from "../../../components/Typography/Typography";
import RequestTimeOffModal from "../EmployeeTimeOff/RequestTimeOffModal";
import TimeOffDetailsModal from "../EmployeeTimeOff/TimeOffDetailsModal";
import CalenderSlider from "../CalenderSlider";
import TimeOffHistoryModal from "../EmployeeTimeOff/TimeOffHistoryModal";
import SingleTimeOffHistoryModal from "../EmployeeTimeOff/SingleTimeOffHistoryModal";
import { useAppDispatch } from "../../../hooks";
import {
  getCalenderTimeOffAsync,
  getLeaveStatisticsAsync,
  getSummaryTimeoffAsync,
} from "../../../services/reducers/leaveReducer";
import { formatDateMonth, getDayAndMonth } from "../../../utils/common";
import emptyTimeOffImage from "../../../images/emptyTimeOff.svg";
import TimeOffCalenderEmpty from "./TimeOffCalenderEmpty";
import LeaveBalanceEmpty from "./LeaveBalanceEmpty";
import ColorLabel from "../ColorLable";

type Props = {
  financialyearList: any;
  setStartMonth: React.Dispatch<React.SetStateAction<string>>;
  setEndMonth: React.Dispatch<React.SetStateAction<string>>;
  setCurrentSlide: React.Dispatch<React.SetStateAction<number>>;
  calenderDetail: any;
  role: string;
  type: string;
  activeTab: string;
  setSelectedDate: React.Dispatch<React.SetStateAction<any>>;
  calenderDate: any;
  tab: string;
  currentSlide: number;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
  getSettingList: any;
  current: number;
  selectedDate: any;
};
const AdminMyTimeOff: React.FC<Props> = ({
  financialyearList,
  setStartMonth,
  setEndMonth,
  calenderDetail,
  role,
  type,
  activeTab,
  setSelectedDate,
  calenderDate,
  tab,
  setCurrentSlide,
  currentSlide,
  setCurrent,
  getSettingList,
  current,
  selectedDate
}) => {
  const [requestTimeOff, setRequestTimeOff] = useState<boolean>(false);
  const [timeOffHistory, setTimeOffHistory] = useState<boolean>(false);
  const [timeOffDetails, setTimeOffDetails] = useState<boolean>(false);
  const [singleTimeOffHistory, setSingleTimeOffHistory] =
    useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [timeSummary, setTimeSummary] = useState<any>([]);
  const [timeoffId, setTimeoffId] = useState("");
  const [leavebalance, setLeavebalance] = useState<any>([]);
  const [timeoffHistoryId, setTimeoffHistoryId] = useState("");
  const isFetching = useRef(false);
  const activeFinancialYear = financialyearList?.records?.find(
    (record: any) => record.isActive
  );

  const fyStartDate = activeFinancialYear
    ? activeFinancialYear.fyStartDate
    : "";
  const fyEndDate = activeFinancialYear ? activeFinancialYear.fyEndDate : "";

  useEffect(() => {
    if (activeTab === "tab1") {
      getSummary();
    }
  }, []);

  const getSummary = () => {
    if (isFetching.current) return;

    isFetching.current = true;
    const request = {
      IsEmployee: true,
    };
    dispatch(getSummaryTimeoffAsync(request)).then((res) => {
      if (res.payload) {
        setTimeSummary(res.payload.records);
        isFetching.current = false;
      }
    });
  };

  useEffect(() => {
    if (activeTab === "tab1") {
      dispatch(getLeaveStatisticsAsync()).then((res) => {
        if (res.payload) {
          setLeavebalance(res.payload);
        }
      });
    }
  }, [activeTab]);

  const handleView = (id: string) => {
    setTimeoffId(id);
    setTimeOffDetails(true);
  };

  const handleHistoryView = (id: string) => {
    setTimeoffHistoryId(id);
    setSingleTimeOffHistory(true);
  };

  // const fyStartDate =
  //   financialyearList?.records?.length > 0
  //     ? financialyearList?.records[0]?.fyStartDate
  //     : "";
  // const fyEndDate =
  //   financialyearList?.records?.length > 0
  //     ? financialyearList?.records[0]?.fyEndDate
  //     : "";

  return (
    <div>
      <div
        className="pt-6 ps-10"
        style={{
          background:
            " linear-gradient(90deg, #E2E2E2 61.11%, rgba(255, 255, 255, 0) 99.1%)",
        }}
      >
        <Typography variant="h6" className="text-gray-300 font-bold">
          My Leave Applications
        </Typography>
        <div className="overflow-y-hidden">
          <div className="flex justify-start items-start">
            <div className="inline-block h-[120px] w-[120px] p-3 bg-pastel-700 border border-pastel-800 rounded-md mb-8 mt-5 cursor-pointer" onClick={() => setRequestTimeOff(true)}>
              <div className="w-full h-full relative">
                <div className="ms-1">
                  <svg
                    width="16"
                    height="22"
                    viewBox="0 0 16 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9908 0.876038H4.51077C0.750771 0.876038 0.46077 4.25604 2.49077 6.09604L13.0108 15.656C15.0408 17.496 14.7508 20.876 10.9908 20.876H4.51077C0.750771 20.876 0.46077 17.496 2.49077 15.656L13.0108 6.09604C15.0408 4.25604 14.7508 0.876038 10.9908 0.876038Z"
                      stroke="#F15845"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button
                  className="flex justify-between items-center text-400 font-normal text-primary-100 w-full absolute bottom-0 left-0"

                >
                  <span className="inline-block">
                    Request
                    <br />
                    Time Off
                  </span>
                  <span className="inline-block">
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.75839 13.2796C7.91118 13.4459 7.98659 13.6393 7.98659 13.8607C7.98659 14.0821 7.91019 14.2755 7.75839 14.4418C7.60559 14.6082 7.42799 14.6902 7.22459 14.6902C7.0212 14.6902 6.8436 14.6071 6.6908 14.4418C6.538 14.2755 6.4626 14.0821 6.4626 13.8607C6.4626 13.8056 6.4626 13.7505 6.48839 13.6944C6.48839 13.6393 6.51419 13.5842 6.53899 13.528C6.56479 13.4729 6.58959 13.4449 6.61539 13.3898C6.64119 13.3347 6.66599 13.3066 6.71659 13.2796C6.89419 13.0863 7.14818 13.0031 7.40218 13.0582C7.45278 13.0582 7.50338 13.0863 7.55497 13.1133C7.60557 13.1413 7.63137 13.1683 7.68197 13.1964C7.68197 13.1975 7.73358 13.2245 7.75839 13.2796ZM10.4004 9.21516C10.0959 9.54675 10.0959 10.0447 10.4004 10.3763C10.5532 10.5426 10.7308 10.6247 10.9342 10.6247C11.1376 10.6247 11.3152 10.5415 11.468 10.3763C11.7726 10.0447 11.7726 9.54675 11.468 9.21516C11.1872 8.91164 10.705 8.91164 10.4004 9.21516ZM8.54608 11.2339C8.24149 11.5655 8.24149 12.0634 8.54608 12.395C8.69887 12.5614 8.87648 12.6435 9.07987 12.6435C9.28327 12.6435 9.46087 12.5603 9.61367 12.395C9.91826 12.0634 9.91826 11.5655 9.61367 11.2339C9.30809 10.9293 8.85067 10.9293 8.54608 11.2339ZM13.5239 7.61107C13.5239 7.55599 13.4981 7.5009 13.4733 7.44473C13.4475 7.38965 13.4227 7.33456 13.3969 7.30648C13.3711 7.25139 13.3463 7.22331 13.2957 7.16822C13.0159 6.86362 12.5079 6.86362 12.2291 7.16822C12.2033 7.19631 12.1527 7.25139 12.1279 7.30648C12.1021 7.36157 12.0773 7.38965 12.0515 7.44473C12.0257 7.49982 12.0257 7.55491 12.0009 7.61107C12.0009 7.66616 11.9751 7.72124 11.9751 7.77741C11.9751 7.8325 11.9751 7.88758 12.0009 7.94375C12.0009 7.99883 12.0267 8.05392 12.0515 8.11009C12.0773 8.16517 12.1021 8.22026 12.1279 8.24834C12.1537 8.30343 12.1785 8.33151 12.2291 8.38659C12.2549 8.41468 12.3055 8.46976 12.3303 8.49677C12.3809 8.52485 12.4067 8.55185 12.4573 8.57994C12.5079 8.60802 12.5585 8.60802 12.6101 8.63502C12.6607 8.63502 12.7113 8.66311 12.7629 8.66311C12.9663 8.66311 13.1439 8.57994 13.2967 8.41468C13.3225 8.38659 13.3731 8.33151 13.3979 8.27642C13.4237 8.22134 13.4485 8.19325 13.4743 8.13817C13.5001 8.08308 13.5001 8.02799 13.5249 7.97183C13.5249 7.91674 13.5507 7.86166 13.5507 7.80549C13.5497 7.72232 13.5497 7.66724 13.5239 7.61107ZM10.4005 5.17864C10.0959 5.51023 10.0959 6.00817 10.4005 6.33976C10.5533 6.5061 10.7309 6.58819 10.9343 6.58819C11.1377 6.58819 11.3153 6.50502 11.4681 6.33976C11.7727 6.00817 11.7727 5.51023 11.4681 5.17864C11.1873 4.84597 10.7051 4.84597 10.4005 5.17864ZM8.54613 3.15989C8.24154 3.49148 8.24154 3.98942 8.54613 4.32101C8.69892 4.48735 8.87653 4.56944 9.07993 4.56944C9.28332 4.56944 9.46092 4.48627 9.61372 4.32101C9.91831 3.98942 9.91831 3.49148 9.61372 3.15989C9.30814 2.8283 8.85072 2.8283 8.54613 3.15989ZM7.63134 1.03098C7.58074 1.0029 7.55494 0.975897 7.50434 0.947814C7.45374 0.919732 7.40314 0.919732 7.35155 0.892728C7.09755 0.837642 6.84356 0.92081 6.66597 1.11415C6.51317 1.28049 6.43777 1.47384 6.43777 1.69527C6.43777 1.75035 6.43777 1.80544 6.46356 1.8616C6.46356 1.91669 6.48936 1.97178 6.51416 2.02794C6.53996 2.08303 6.56476 2.11111 6.59056 2.1662C6.61635 2.22128 6.64116 2.24936 6.69176 2.27637C6.84456 2.44271 7.02216 2.5248 7.22556 2.5248C7.42895 2.5248 7.60655 2.44163 7.75935 2.27637C7.91215 2.11003 7.98755 1.91668 7.98755 1.69526C7.98755 1.47383 7.91116 1.28049 7.75935 1.11414C7.73356 1.08606 7.68194 1.05799 7.63134 1.03098ZM3.97424 6.94775C3.56744 6.94775 3.21226 7.30744 3.21226 7.77728C3.21226 8.22014 3.54265 8.60681 3.97424 8.60681C4.38104 8.60681 4.73623 8.24713 4.73623 7.77728C4.73623 7.33442 4.40583 6.94775 3.97424 6.94775ZM7.25027 7.77728C7.25027 7.33442 6.91988 6.94775 6.48829 6.94775C6.08149 6.94775 5.7263 7.30744 5.7263 7.77728C5.7263 8.22014 6.0567 8.60681 6.48829 8.60681C6.89509 8.60681 7.25027 8.22014 7.25027 7.77728ZM9.00342 8.60681C9.41022 8.60681 9.76541 8.24713 9.76541 7.77728C9.76541 7.33442 9.43501 6.94775 9.00342 6.94775C8.59662 6.94775 8.24144 7.30744 8.24144 7.77728C8.24144 8.22014 8.57084 8.60681 9.00342 8.60681ZM1.45901 6.94775C1.05221 6.94775 0.697021 7.30744 0.697021 7.77728C0.697021 8.22014 1.02742 8.60681 1.45901 8.60681C1.86581 8.60681 2.22099 8.24713 2.22099 7.77728C2.22099 7.33442 1.89159 6.94775 1.45901 6.94775Z"
                        fill="#F15845"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div className="inline-block whitespace-nowrap w-[calc(100%-136px)] overflow-x-auto ms-4">
              {timeSummary &&
                timeSummary.map((t: any) => (
                  <div
                    className="inline-block h-[120px] w-[240px] shadow-400 border border-gray-1200 rounded-md mb-8 mt-5 overflow-hidden me-4 cursor-pointer"
                    onClick={() => handleView(t?.id)}
                  >
                    <div className="h-[68px] w-full flex justify-start items-center p-4 bg-white rounded-t-md overflow-hidden">
                      <div>
                        <div className="text-600 text-gray-300 font-bold flex justify-start items-center">
                          {getDayAndMonth(t?.startDate).day}{" "}
                          <span className="text-200 font-light ms-0.5">
                            {getDayAndMonth(t?.startDate).month}
                          </span>
                          <span className="font-light mx-1">-</span>
                          {getDayAndMonth(t?.endDate).day}
                          <span className="text-200 font-light ms-0.5">
                            {getDayAndMonth(t?.endDate).month}
                          </span>
                        </div>
                        {/* <div
                          className={`flex justify-center items-center px-2 py-1 mt-1 gap-2 text-100 font-normal rounded-full text-white ${
                            t?.isApproved === true
                              ? "bg-green-100"
                              : "bg-pastel-900"
                          }`}
                        > */}
                        <ColorLabel text={t?.leave?.leaveCode === "RH" ? "Holiday" : t?.leave?.title} className="!h-auto !w-auto !text-100 !font-normal !px-2.5 !py-1 !rounded-2xl text-white">
                          <span>{t?.leave?.title}</span>{" "}
                          <span className="font-bold">{t?.requestFor}d</span>
                          {/* </div> */}
                        </ColorLabel>
                      </div>
                    </div>
                    <div className="h-[calc(100%-68px)] bg-gray-200 flex justify-end items-center ps-7 pe-5">
                      {t?.isApproved === false && (
                        <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                          <div className="flex justify-start items-center text-200 font-normal text-primary-100 py-1 px-3 capitalize rounded-full bg-primary-100 bg-opacity-10">
                            <span className="me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="16"
                                viewBox="0 0 14 16"
                                fill="none"
                              >
                                <path
                                  d="M7 0.5C10.866 0.5 14 3.8579 14 8C14 12.1421 10.866 15.5 7 15.5C3.13404 15.5 0 12.1421 0 8C0 3.8579 3.13404 0.5 7 0.5ZM3.45698 10.2107C3.04833 10.6485 3.04833 11.3584 3.45698 11.7961C3.86564 12.2339 4.52819 12.2339 4.93668 11.7961L7 9.58539L9.06332 11.7961C9.47198 12.2339 10.1345 12.2339 10.543 11.7961C10.9517 11.3582 10.9517 10.6484 10.543 10.2107L8.47969 8L10.543 5.7893C10.9517 5.35145 10.9517 4.64158 10.543 4.20391C10.1344 3.76607 9.47182 3.76607 9.06332 4.20391L7 6.41461L4.93668 4.20391C4.52802 3.76607 3.86548 3.76607 3.45698 4.20391C3.04833 4.64175 3.04833 5.35163 3.45698 5.7893L5.52031 8L3.45698 10.2107Z"
                                  fill="#F15845"
                                />
                              </svg>
                            </span>
                            Denied
                          </div>
                        </div>
                      )}
                      {t?.isLeaveCancelled === true ? (
                        <div className="flex justify-start items-center text-200 text-secondary-300 bg-secondary-300 bg-opacity-10 capitalize py-1 px-3 rounded-full">
                          <span className="me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M8 0.5C3.8579 0.5 0.5 3.8579 0.5 8C0.5 12.1421 3.8579 15.5 8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.8579 12.1421 0.5 8 0.5ZM11.7961 10.2107C12.2339 10.6485 12.2339 11.3584 11.7961 11.7961C11.3582 12.2339 10.6484 12.2339 10.2107 11.7961L8 9.58539L5.7893 11.7961C5.35145 12.2339 4.64158 12.2339 4.20391 11.7961C3.76607 11.3582 3.76607 10.6484 4.20391 10.2107L6.41461 8L4.20391 5.7893C3.76607 5.35145 3.76607 4.64158 4.20391 4.20391C4.64175 3.76607 5.35163 3.76607 5.7893 4.20391L8 6.41461L10.2107 4.20391C10.6485 3.76607 11.3584 3.76607 11.7961 4.20391C12.2339 4.64175 12.2339 5.35163 11.7961 5.7893L9.58539 8L11.7961 10.2107Z"
                                fill="#ECB22E"
                              />
                            </svg>
                          </span>
                          Cancelled
                        </div>
                      ) : (
                        t?.isApproved === true && (
                          <div className="flex justify-start items-center text-200 text-green-100 bg-green-100 bg-opacity-10 capitalize py-1 px-3 rounded-full">
                            <span className="me-1">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 13 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.56763 12.6872C9.86763 12.6872 12.5676 9.9872 12.5676 6.68719C12.5676 3.38719 9.86763 0.687195 6.56763 0.687195C3.26763 0.687195 0.567627 3.38719 0.567627 6.68719C0.567627 9.9872 3.26763 12.6872 6.56763 12.6872Z"
                                  fill="#2EB67D"
                                />
                                <path
                                  d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                  fill="#2EB67D"
                                />
                                <path
                                  d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            Approved
                          </div>
                        )
                      )}
                      {/* {t?.isApproved === true && (

                        <div className="flex justify-start items-center text-200 text-green-100 bg-green-100 bg-opacity-10 capitalize py-1 px-3 rounded-full">
                          <span className="me-1">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 13 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.56763 12.6872C9.86763 12.6872 12.5676 9.9872 12.5676 6.68719C12.5676 3.38719 9.86763 0.687195 6.56763 0.687195C3.26763 0.687195 0.567627 3.38719 0.567627 6.68719C0.567627 9.9872 3.26763 12.6872 6.56763 12.6872Z"
                                fill="#2EB67D"
                              />
                              <path
                                d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                fill="#2EB67D"
                              />
                              <path
                                d="M4.01782 6.68726L5.71582 8.38526L9.11782 4.98926"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          Approved
                        </div>
                      )} */}
                      {t?.isApproved === null && (
                        <div className="flex justify-start items-center text-200 text-gray-500 bg-gray-100 font-normal capitalize py-1 px-3 rounded-full">
                          <span className="me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M15.9949 13.8477C15.9742 13.6151 15.8932 13.3733 15.7516 13.1286L9.14024 1.67721C8.99942 1.43254 8.83087 1.24124 8.63955 1.10681C8.44183 0.968837 8.22063 0.896301 8.00016 0.896301C7.77969 0.896301 7.55849 0.968846 7.36078 1.10681C7.16946 1.24052 7.0009 1.43256 6.86009 1.67721L0.247964 13.1286C0.107143 13.3733 0.0253453 13.6151 0.00473477 13.8477C-0.0158903 14.0873 0.0310496 14.3156 0.142001 14.507C0.25224 14.6983 0.425778 14.8533 0.644118 14.955C0.855358 15.0539 1.10571 15.1037 1.38805 15.1037H14.611C14.8934 15.1037 15.1437 15.0539 15.3549 14.955C15.5733 14.8533 15.7468 14.6983 15.8571 14.507C15.9687 14.3156 16.0162 14.0873 15.9949 13.8477ZM8.00009 13.0404C7.55558 13.0404 7.19499 12.6798 7.19499 12.2353C7.19499 11.7908 7.55558 11.4309 8.00009 11.4309C8.4446 11.4309 8.80519 11.7908 8.80519 12.2353C8.80519 12.6798 8.4446 13.0404 8.00009 13.0404ZM8.96735 5.8728L8.70917 10.1358C8.69423 10.3919 8.47091 10.6017 8.21415 10.6017H7.78457C7.52781 10.6017 7.30521 10.3919 7.28956 10.1358L7.03138 5.8728C7.01573 5.61677 7.21274 5.40695 7.46948 5.40695H8.52706C8.78524 5.40766 8.98299 5.61675 8.96735 5.8728Z"
                                fill="#888888"
                              />
                            </svg>
                          </span>
                          Pending
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="min-h-[calc(100vh-400px)] w-full">
        <div className="px-10 pt-9 pb-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <div className="flex justify-between items-center">
                <Typography variant="h6" className="text-gray-300 font-bold">
                  Leave Balances
                </Typography>
                {/* <div className="text-gray-1400 text-100 font-normal">
                  Click any leave account to view details
                </div> */}
              </div>
              <div
                className="border border-gray-100 rounded-md mt-4 bg-white h-[31.188rem] overflow-auto"
                style={{ boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.05)" }}
              >
                {leavebalance && leavebalance.length > 0 ? (
                  leavebalance.map((t: any) => (
                    t?.maximumLeave > 0 && (
                    (t?.leaves?.leaveCode !== "LOP" || t?.availedLeave > 0) && (
                      <div
                        className={`flex justify-start items-center h-[52px] w-full border-b border-black border-opacity-10 first:rounded-t-md last:rounded-b-md cursor-pointer ${t?.leaves?.leaveCode === "LOP"
                            ? "hover:bg-primary-100 hover:bg-opacity-20  bg-primary-100 bg-opacity-10"
                            : " hover:bg-gray-1500"
                          }`}
                        onClick={() => handleHistoryView(t?.leaves?.leaveId)}
                      >
                        <div className="w-[9.375rem] flex justify-start items-center border-r border-black border-opacity-10 h-full ps-3">
                          <div className="me-2.5 [&>div]:!h-[14px] [&>div]:!w-[5px] [&>div]:!rounded-2xl">
                            <ColorLabel text={t?.leaves?.title} /></div>
                          <div
                            className={`text-200 font-medium relative ${t?.leaves?.leaveCode === "LOP"
                                ? "text-primary-100"
                                : "text-gray-300"
                              }`}
                          >
                            {t?.leaves?.title}

                          </div>
                        </div>
                        <div className="w-[calc(100%-15.375rem)] flex justify-start items-center border-r border-black border-opacity-10 h-full">
                          <div
                            className="h-5 bg-gray-1200"
                            style={{ width: `95%` }}
                          >
                            <div
                              className="h-full bg-gray-1300"
                              style={{
                                width: `${(t?.availedLeave / t.maximumLeave) * 100
                                  }%`,
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="w-[6rem] h-full flex justify-center items-center">
                          <div className="text-gray-300 text-100 font-bold">
                            {t?.leaves?.leaveCode === "LOP" ? (
                              t?.availedLeave
                            ) : (
                              <span>
                                {t?.availedLeave}
                                <span className="mx-1">of</span>
                                {t?.maximumLeave}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  )))
                ) : (
                  <LeaveBalanceEmpty />
                )}
              </div>
            </div>

            <div className="">
              <div className="h-full w-full flex flex-col grow">
                <Typography variant="h6" className="text-gray-300 font-bold">
                  Time Off Calendar
                </Typography>
                <div
                  className="border border-gray-100 rounded-md mt-4 bg-white grow flex flex-col h-[31.188rem]"
                  style={{ boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.05)" }}
                >
                  {calenderDetail ? (
                    <CalenderSlider
                      setStartMonth={setStartMonth}
                      setEndMonth={setEndMonth}
                      setSelectedDate={setSelectedDate}
                      calenderDetail={calenderDetail}
                      fyStartDate={fyStartDate}
                      fyEndDate={fyEndDate}
                      setCurrentSlide={setCurrentSlide}
                      currentSlide={currentSlide}
                      setCurrent={setCurrent}
                      current={current}
                      selectedDate={selectedDate}
                    />
                  ) : (
                    <TimeOffCalenderEmpty />
                  )}
                  <div className="border-t border-black border-opacity-10 pt-5 bg-gray-400 rounded-b-md grow flex flex-col overflow-auto">
                    <div className="text-200 text-gray-300 font-nomal opacity-70 px-5 mb-1">
                      Time Off Requests
                    </div>
                    <div className="overflow-auto px-5">
                      {calenderDate?.length > 0 ? (
                        calenderDate?.map((t: any) => (
                          <div className="">
                            <div className="flex justify-start items-center py-3 border-b border-black border-opacity-10">
                              <div className="w-[7.125rem]">
                                <div className="text-200 text-gray-300 font-semibold">
                                  {getDayAndMonth(t?.startDate).month}{" "}
                                  {getDayAndMonth(t?.startDate).day} -{" "}
                                  {getDayAndMonth(t?.endDate).month}{" "}
                                  {getDayAndMonth(t?.endDate).day}
                                </div>
                              </div>
                              <div className="w-[4.688rem]">
                                <div className="text-200 text-gray-300 font-semibold">
                                  {t?.leave?.leaveCode === null
                                    ? t?.leave?.maxLeaves
                                    : t?.requestFor}{" "}
                                  <span className="font-normal">
                                    {" "}
                                    {t?.requestFor !== null && t?.requestFor > 1
                                      ? "Days"
                                      : "Day"}
                                  </span>
                                </div>
                              </div>
                              <div className="w-[7.125rem]">
                                <div className="text-200 text-gray-300 font-normal opacity-70">
                                  {t?.leave?.title}
                                </div>
                              </div>
                              {t?.isApproved === true &&
                                t?.leave?.leaveCode !== null && (
                                  <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                                    <div className="flex justify-start items-center text-[8px] uppercase font-normal text-green-100 py-1 px-2.5 rounded-full bg-green-100 bg-opacity-10">
                                      <span className="me-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="17"
                                          viewBox="0 0 17 17"
                                          fill="none"
                                        >
                                          <path
                                            d="M8.50952 16.512C12.9095 16.512 16.5095 12.912 16.5095 8.51196C16.5095 4.11196 12.9095 0.511963 8.50952 0.511963C4.10952 0.511963 0.509521 4.11196 0.509521 8.51196C0.509521 12.912 4.10952 16.512 8.50952 16.512Z"
                                            fill="#2EB67D"
                                          />
                                          <path
                                            d="M5.10986 8.51205L7.37386 10.776L11.9099 6.24805"
                                            fill="#2EB67D"
                                          />
                                          <path
                                            d="M5.10986 8.51205L7.37386 10.776L11.9099 6.24805"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </span>
                                      Approved
                                    </div>
                                  </div>
                                )}
                              {t?.isApproved === null &&
                                t?.leave?.leaveCode !== null && (
                                  <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                                    <div className="flex justify-start items-center text-[8px] uppercase font-normal text-gray-700 py-1 px-2.5 rounded-full bg-gray-100">
                                      <span className="me-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.4949 13.8477C16.4742 13.6151 16.3932 13.3733 16.2516 13.1286L9.64024 1.67721C9.49942 1.43254 9.33087 1.24124 9.13955 1.10681C8.94183 0.968837 8.72063 0.896301 8.50016 0.896301C8.27969 0.896301 8.05849 0.968846 7.86078 1.10681C7.66946 1.24052 7.5009 1.43256 7.36009 1.67721L0.747964 13.1286C0.607143 13.3733 0.525345 13.6151 0.504735 13.8477C0.48411 14.0873 0.53105 14.3156 0.642001 14.507C0.75224 14.6983 0.925778 14.8533 1.14412 14.955C1.35536 15.0539 1.60571 15.1037 1.88805 15.1037H15.111C15.3934 15.1037 15.6437 15.0539 15.8549 14.955C16.0733 14.8533 16.2468 14.6983 16.3571 14.507C16.4687 14.3156 16.5162 14.0873 16.4949 13.8477ZM8.50009 13.0404C8.05558 13.0404 7.69499 12.6798 7.69499 12.2353C7.69499 11.7908 8.05558 11.4309 8.50009 11.4309C8.9446 11.4309 9.30519 11.7908 9.30519 12.2353C9.30519 12.6798 8.9446 13.0404 8.50009 13.0404ZM9.46735 5.8728L9.20917 10.1358C9.19423 10.3919 8.97091 10.6017 8.71415 10.6017H8.28457C8.02781 10.6017 7.80521 10.3919 7.78956 10.1358L7.53138 5.8728C7.51573 5.61677 7.71274 5.40695 7.96948 5.40695H9.02706C9.28524 5.40766 9.48299 5.61675 9.46735 5.8728Z"
                                            fill="#888888"
                                          />
                                        </svg>
                                      </span>
                                      PENDING
                                    </div>
                                  </div>
                                )}
                              {t?.isApproved === false &&
                                t?.leave?.leaveCode !== null && (
                                  <div className="w-[calc(100%-20.938rem)] flex justify-end items-center">
                                    <div className="flex justify-start items-center text-[8px] uppercase font-normal text-primary-100 py-1 px-2.5 rounded-full bg-primary-100 bg-opacity-10">
                                      <span className="me-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="14"
                                          height="16"
                                          viewBox="0 0 14 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M7 0.5C10.866 0.5 14 3.8579 14 8C14 12.1421 10.866 15.5 7 15.5C3.13404 15.5 0 12.1421 0 8C0 3.8579 3.13404 0.5 7 0.5ZM3.45698 10.2107C3.04833 10.6485 3.04833 11.3584 3.45698 11.7961C3.86564 12.2339 4.52819 12.2339 4.93668 11.7961L7 9.58539L9.06332 11.7961C9.47198 12.2339 10.1345 12.2339 10.543 11.7961C10.9517 11.3582 10.9517 10.6484 10.543 10.2107L8.47969 8L10.543 5.7893C10.9517 5.35145 10.9517 4.64158 10.543 4.20391C10.1344 3.76607 9.47182 3.76607 9.06332 4.20391L7 6.41461L4.93668 4.20391C4.52802 3.76607 3.86548 3.76607 3.45698 4.20391C3.04833 4.64175 3.04833 5.35163 3.45698 5.7893L5.52031 8L3.45698 10.2107Z"
                                            fill="#F15845"
                                          />
                                        </svg>
                                      </span>
                                      DENIED
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="flex justify-center items-center text-center h-[9.375rem]">
                          <div className="">
                            <div className="flex justify-center">
                              <img
                                src={emptyTimeOffImage}
                                alt={emptyTimeOffImage}
                              />
                            </div>
                            <div className="text-gray-700 text-400 font-normal mt-2.5">
                              Time off data for the two<br></br> months
                              will be shown here.
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {timeOffHistory && (
                    <TimeOffHistoryModal
                      onClose={() => setTimeOffHistory(false)}
                      leavebalance={leavebalance}
                      timeoffHistoryId={timeoffHistoryId}
                    />
                  )}
                  {singleTimeOffHistory && (
                    <SingleTimeOffHistoryModal
                      onClose={() => setSingleTimeOffHistory(false)}
                      leavebalance={leavebalance}
                      timeoffHistoryId={timeoffHistoryId}
                    />
                  )}
                  {requestTimeOff && (
                    <RequestTimeOffModal
                      onClose={() => setRequestTimeOff(false)}
                      financialyearList={financialyearList}
                      setRequestTimeOff={setRequestTimeOff}
                      getSummary={getSummary}
                      type={type}
                      tab={tab}
                    />
                  )}
                  {timeOffDetails && (
                    <TimeOffDetailsModal
                      onClose={() => setTimeOffDetails(false)}
                      timeoffId={timeoffId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMyTimeOff;
